import React, { useState } from 'react';
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import './UploadOrganizationView.css'

import { apiUrl } from '../../../utility/Connections';

import { Typography, Layout, Divider, Button, Input } from 'antd';
import FileUploaderAuto from '../../../components/fileUploader/fileUploaderAuto';
import LoadingOverlay from '../../../components/loadingOverlay/loadingOverlay';
const { Paragraph, Title } = Typography;
const { Content } = Layout;

const UploadOrganizationView = () => {

    const [fileCharged, setFileCharged] = useState(false)
    const [selectedFile, setSelectedFile] = useState("")
    const [newUserName, setNewUserName] = useState("")
    const [newPassword, setNewPassword] = useState(null)
    const [showLoading, setShowLoading] = useState(false)
    const [loadingText, setLoadingText] = useState("")
    const [uploadProgress, setUploadProgress] = useState(0)
    const [isUploading, setIsUploading] = useState(false)
    const [userNameError, setUserNameError] = useState(null)

    const showSwal = (text, type, title) => {
        let swalType = "";
        if (type === 0) {
            swalType = "error";
        }
        if (type === 1) {
            swalType = "warning";
        }
        if (type === 2) {
            swalType = "success";
        }
        withReactContent(Swal).fire({
            title: title,
            icon: swalType,
            text: text,
            confirmButtonColor: "#012E40",
            cancelButtonColor: "#FF4D4F",
        })
    }

    const handleChangeFile = () => {
        setFileCharged(false)
    }

    const selectFile = (files) => {
        setSelectedFile(files[0])
        setFileCharged(true)
    }

    const handleUserNameChange = (e) => {
        const value = e.target.value;
        if (value.includes(' ')) {
            setUserNameError('El nombre de usuario no puede contener espacios. Usa _ o - como separador.');
            return;
        }
        setUserNameError(null);
        setNewUserName(value);
    }

    const validateAndUpload = async () => {
        // Validación frontend
        if (!newUserName || newUserName.length < 6) {
            showSwal('El nombre de usuario debe tener al menos 6 caracteres.', 0, 'Usuario inválido');
            return;
        }
        if (!newPassword || !fileCharged) return;

        // Pre-validación contra BD
        setShowLoading(true);
        setLoadingText('Validando datos...');
        const token = localStorage.getItem('access_token');
        const formData = new FormData();
        formData.append('file', selectedFile);
        formData.append('org_username', newUserName);

        try {
            const res = await fetch(`${apiUrl}/files/validate-org-upload/`, {
                method: 'POST',
                body: formData,
                headers: { 'Authorization': `Bearer ${token}` },
            });
            const result = await res.json();
            setShowLoading(false);

            if (result.status === 'username_taken') {
                showSwal(
                    'El nombre de usuario ya está registrado para otra organización. Por favor elige un nombre de usuario diferente.',
                    0,
                    'Usuario no disponible'
                );
                return;
            }

            if (result.status === 'nit_exists') {
                const confirm = await withReactContent(Swal).fire({
                    title: 'Organización ya registrada',
                    icon: 'warning',
                    html: `<p>La organización <b>${result.org_name}</b> ya está registrada con ese NIT.</p><p>¿Deseas actualizar su información, incluyendo el usuario y contraseña del administrador?</p>`,
                    showCancelButton: true,
                    confirmButtonText: 'Sí, actualizar',
                    cancelButtonText: 'Cancelar',
                    confirmButtonColor: '#012E40',
                    cancelButtonColor: '#FF4D4F',
                });
                if (!confirm.isConfirmed) return;
            }

            // Proceder con la carga real
            uploadFile();
        } catch (error) {
            setShowLoading(false);
            showSwal(`Error de validación: ${error.message}`, 0, 'Error');
        }
    }

    const uploadFile = async () => {
        setShowLoading(true);
        setIsUploading(true);
        setUploadProgress(0);
        setLoadingText("Iniciando carga...");

        const formData = new FormData();
        formData.append("file", selectedFile);
        formData.append("org_username", newUserName);
        formData.append("org_password", newPassword);

        const token = localStorage.getItem('access_token');

        try {
            const response = await fetch(`${apiUrl}/files/upload-organization/`, {
                method: 'POST',
                body: formData,
                headers: {
                    'Authorization': `Bearer ${token}`,
                },
            });

            if (!response.ok && !response.body) {
                const errData = await response.json().catch(() => ({}));
                throw new Error(errData.error || `Error ${response.status}`);
            }

            if (!response.body) {
                throw new Error('El servidor no soporta respuestas en streaming.');
            }

            const reader = response.body.getReader();
            const decoder = new TextDecoder();
            let buffer = '';

            while (true) {
                const { done, value } = await reader.read();
                if (done) break;

                buffer += decoder.decode(value, { stream: true });
                const lines = buffer.split('\n');
                buffer = lines.pop();

                for (const line of lines) {
                    if (!line.trim()) continue;
                    let event;
                    try {
                        event = JSON.parse(line);
                    } catch {
                        continue;
                    }

                    if (event.type === 'progress') {
                        setLoadingText(event.message || 'Procesando...');
                        setUploadProgress(event.percent || 0);
                    } else if (event.type === 'validation_error') {
                        setShowLoading(false);
                        setIsUploading(false);
                        const errorList = (event.detalle_errores || [])
                            .map(e => `Fila ${e.fila}: ${(e.errores || []).join(', ')}`)
                            .join('\n');
                        withReactContent(Swal).fire({
                            title: event.error || 'Errores en el archivo',
                            icon: 'error',
                            html: `<p>Filas con errores: <b>${event.filas_con_errores}</b> de <b>${event.total_filas}</b></p><pre style="text-align:left;max-height:250px;overflow:auto;font-size:12px">${errorList}</pre>`,
                            confirmButtonColor: "#012E40",
                        });
                        return;
                    } else if (event.type === 'server_error') {
                        setShowLoading(false);
                        setIsUploading(false);
                        if (event.missing_columns) {
                            showSwal(`Columnas faltantes: ${event.missing_columns.join(', ')}`, 0, "Error en el archivo");
                        } else {
                            showSwal(event.error || 'Error desconocido', 0, "Error");
                        }
                        return;
                    } else if (event.type === 'done') {
                        setUploadProgress(100);
                        setShowLoading(false);
                        setIsUploading(false);
                        resetStates();
                        const orgLabel = event.org_name
                            ? `Organización: ${event.org_name}`
                            : '';
                        if (event.errores > 0) {
                            const errorList = (event.detalle_errores || [])
                                .map(e => `Fila ${e.fila || e.lote}: ${e.error || (e.errores || []).join(', ')}`)
                                .join('\n');
                            withReactContent(Swal).fire({
                                title: 'Carga parcial',
                                icon: 'warning',
                                html: `<p>${orgLabel}</p><p>Creados: <b>${event.creados}</b> | Actualizados: <b>${event.actualizados}</b> | Errores: <b>${event.errores}</b></p><pre style="text-align:left;max-height:200px;overflow:auto;font-size:12px">${errorList}</pre>`,
                                confirmButtonColor: "#012E40",
                            });
                        } else {
                            showSwal(`${orgLabel ? orgLabel + '. ' : ''}Creados: ${event.creados || 0}, Actualizados: ${event.actualizados || 0}`, 2, "Carga exitosa");
                        }
                        return;
                    }
                }
            }

            // Stream cerrado sin evento 'done'
            setShowLoading(false);
            setIsUploading(false);
            showSwal('La carga finalizó sin respuesta esperada del servidor.', 1, "Advertencia");
        } catch (error) {
            setShowLoading(false);
            setIsUploading(false);
            showSwal(`Error de conexión: ${error.message}`, 0, "Error");
            console.error('Error en carga de organización (streaming):', error);
        }
    };

    const resetStates = () => {
        setFileCharged(false)
        setSelectedFile("")
        setNewUserName("")
        setNewPassword(null)
        setUserNameError(null)
    }

    return <div className='main-container'>
        {
            showLoading && <LoadingOverlay text={loadingText} showProgress={isUploading} progress={uploadProgress} />
        }
        <Content className='main-subcontainer'>
            {/* <SideMenuAdmin /> */}
            <div className='layout-content'>
                <Typography className='display-center-row display-center-column'>
                    <Title type='primary' level={3}>Administración de organizaciones</Title>
                    <Paragraph>
                        Configure y cargue sus archivos desde esta sección. Siga los siguientes pasos:
                        <ol style={{ marginTop: 10, marginBottom: 10 }}>
                            <li>Llena el formulario para asignar nombre de usuario y contraseña al adminsitrador de la organización</li>
                            <li>Da click en el cargador o arrastra tu archivo a la zona de carga del archivo</li>
                            <li>Da click en el botón "Crear organización"</li>
                        </ol>
                    </Paragraph>
                </Typography>
                <div className='display-center-row display-center-column align-full-center'>
                    <div style={{ width: "80%", backgroundColor: "white" }} className='display-center-row main-subcontainer'>
                        <div className='display-center-row display-center-column align-full-center uploader-container fileinfo-container' >
                            <div className='display-center-row display-center-column'>
                                <span>Nombre de usuario</span>
                                <Input
                                    value={newUserName}
                                    style={{ width: 'auto', marginTop: 10 }}
                                    onChange={handleUserNameChange}
                                    status={userNameError ? 'error' : ''}
                                    minLength={6}
                                />
                                {userNameError && (
                                    <span style={{ color: '#FF4D4F', fontSize: 12, marginTop: 4, maxWidth: 280 }}>
                                        {userNameError}
                                    </span>
                                )}
                                {newUserName && newUserName.length < 6 && !userNameError && (
                                    <span style={{ color: '#faad14', fontSize: 12, marginTop: 4 }}>
                                        Mínimo 6 caracteres ({newUserName.length}/6)
                                    </span>
                                )}
                            </div>
                            <div style={{ marginTop: 20 }} className='display-center-row display-center-column'>
                                <span>Contraseña</span>
                                <Input value={newPassword} style={{ width: 'auto', marginTop: 10 }} onChange={(ele) => setNewPassword(ele.target.value)} />
                            </div>
                        </div>
                        {
                            fileCharged ? <div className='display-center-row display-center-column align-full-center uploader-container' >
                                <p className='filename-tag'>{selectedFile.name}</p>
                                <Button style={{ width: 'auto' }} type="primary" danger onClick={handleChangeFile}>Cambiar archivo</Button>
                            </div> : <div className='display-center-row display-center-column uploader-container'>
                                <FileUploaderAuto mostrarData={selectFile} multi={false} openSwal={showSwal} uploadFile={true} tamanoArchivo={100} />
                            </div>
                        }
                    </div>
                    <Button style={{ width: 'auto', marginTop: "20px" }} type="primary" onClick={validateAndUpload} disabled={!newUserName || newUserName.length < 6 || !newPassword || !fileCharged}>Crear organización</Button>
                </div>
                <Divider />
            </div>
        </Content>
    </div>
}

export default UploadOrganizationView;